var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.25em",
    height: "1.25em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.122 14.523c-.637 0-1.192-.247-1.57-.703a1.912 1.912 0 01-.414-1.535l.435-2.646-.1.05c-.503.247-1.12.057-1.38-.423-.258-.48-.06-1.07.444-1.316l1.892-.93a1.064 1.064 0 011.068.077c.313.216.472.581.412.945l-.744 4.522c.15-.015.534-.105 1.25-.58a1.055 1.055 0 011.424.245.95.95 0 01-.256 1.361c-.894.594-1.661.898-2.344.93l-.117.003zM10.291 6.207c.632 0 1.143-.489 1.143-1.091 0-.603-.511-1.092-1.143-1.092-.63 0-1.143.489-1.143 1.092 0 .602.512 1.09 1.143 1.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.097c-5.514 0-10-4.284-10-9.549S4.486 0 10 0s10 4.284 10 9.548c0 5.265-4.486 9.549-10 9.549zm0-17.142c-4.385 0-7.952 3.407-7.952 7.593 0 4.187 3.567 7.593 7.952 7.593s7.952-3.406 7.952-7.593c0-4.186-3.567-7.593-7.952-7.593z"
  })));
}

export default SvgInfoCircle;